import {Box} from "@variocube/app-api";
import {Item} from "../types";
import * as React from "react";
import {useCallback, useState} from "react";
import {ItemSelectionView} from "./ItemSelectionView";
import {MessageView, PendingView, PushButton, useAsync, useDeactivateListener, usePlatform} from "@variocube/cube-ui";
import {StorageBoxAccess} from "./StorageBoxAccess";
import {ACCESS_CODE_SHAPE} from "./types";
import {useLocalization} from "../../i18n";

export interface StoreBoxFlowProps {
    box: Box;
    onDone: () => void;
}

export function StoreBoxFlow({box, onDone}: StoreBoxFlowProps) {
    const [item, setItem] = useState<Item>();
    const platform = usePlatform();
    const {t} = useLocalization();

    const {error, loading, result: occupancy} = useAsync(async () => {
        if (!item) {
            return undefined;
        }
        return await platform.occupy({
            boxNumber: box.number,
            ...ACCESS_CODE_SHAPE,
            content: {
                item: item.uuid,
            },
        });
    }, [platform, item, box]);

    const handleCancel = useCallback(async () => {
        if (occupancy) {
            await platform.cancelOccupancy(occupancy.uuid);
        }
        onDone();
    }, [platform, occupancy, onDone]);

    useDeactivateListener(handleCancel);

    if (!item) {
        return (
            <ItemSelectionView onSelect={setItem} onCancel={handleCancel}/>
        )
    }
    else if (loading) {
        return <PendingView message={t("OccupyPending")}/>
    }
    else if (error) {
        console.log("Error", error);
        return (
            <MessageView message={t("BoxTypeNotAvailable")}>
                <PushButton onClick={onDone}>
                    {t("Cancel")}
                </PushButton>
            </MessageView>
        )
    }
    else if (occupancy && box) {
        return (
            <StorageBoxAccess
                occupancy={occupancy}
                box={box}
                onDone={onDone}
                item={item}
            />
        );
    }
    return (
        <MessageView message={"Internal error"}>
            <PushButton onClick={onDone}>
                {t("Cancel")}
            </PushButton>
        </MessageView>
    );
}
